module.exports = __webpack_public_path__ + "static/media/logo_text.91f2bd26.png";